
import React, { Component } from 'react';
import { formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import messages from '../../../../locale/messages';
import { api, profilePhotouploadDir } from '../../../../config';

import defaultIcon from '/public/Icons/defaultPreferredProvider.svg';
import tickIcon from '/public/Icons/defaultTickIcon.svg';
import starRatingIcon from '/public/Icons/starRatingIcon.svg';
import bt from '../../../../components/commonStyle.css';

class PreferredProviderList extends Component {

    selectPreferredProvider = ({ id, lat, lng }) => {
        const { change } = this.props;
        change('ManualBookingForm', 'preferredPartnerId', id)
        change('ManualBookingForm', 'preferredPartnerLat', lat)
        change('ManualBookingForm', 'preferredPartnerLng', lng)
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { nearestProviders, preferredPartnerId } = this.props;
        return (
            <div className='preferredProviderList'>
                {nearestProviders?.map((provider) => {
                    let providerPicture = provider?.profile?.picture ? `${api.apiEndpoint + profilePhotouploadDir}medium_${provider?.profile?.picture}` : defaultIcon;
                    let providerAssigned = preferredPartnerId && (preferredPartnerId == provider?.id);
                    return (<div className={'preferredProviderListItem'}>
                        <div className={cx({ ['preferredProviderListImgContainer']: provider?.profile?.picture }, { ['preferredProviderDefaultImgContainer']: !provider?.profile?.picture })}>
                            <img
                                src={providerPicture}
                                alt={provider?.profile?.firstName ? `${provider.profile.firstName} profile photo` : 'Provider profile photo'}
                                className={cx({ ['preferredProviderListImgLogo']: provider?.profile?.picture }, { ['preferredProviderDefaultImgLogo']: !provider?.profile?.picture })}
                            />
                            {(providerAssigned) && <span className='preferredProviderListTick'>
                                <img
                                    src={tickIcon}
                                    alt="Selected"
                                />
                            </span>}
                        </div>
                        <div className='preferredProviderListInfoContainer'>
                            <div className='preferredProviderListInfoWrapper'>
                                <div className='preferredProviderListName'>
                                    <span>{provider?.profile?.firstName}&nbsp;</span>
                                    <span className='preferredProviderListRatingText'>
                                        {(provider?.overallRating > 0 && provider?.completedBookingCount > 0) && <> <span>{'('}</span>
                                            <span>{Math.round(Number(provider?.overallRating) * 10) / 10}&nbsp;</span>
                                            <img src={starRatingIcon} alt="" />
                                            <span>{')'}</span></>}
                                    </span>
                                </div>
                                {provider?.phoneDialCode && provider?.phoneNumber && <div className='preferredProviderListPhoneNo'><span className={bt.displayInlineBlock}>{provider?.phoneDialCode}&nbsp;</span><span className={bt.displayInlineBlock}>{provider?.phoneNumber}</span></div>}
                                {provider?.completedBookingCount >= 0 && <div className='preferredProviderListServiceDesc'>
                                    <span>{`${formatMessage(messages.completedServices)}`}&nbsp;</span>
                                    <span>{`${provider?.completedBookingCount}`}</span>
                                </div>}
                            </div>
                            <div className='preferredProviderListBtnContainer'>
                                {(!preferredPartnerId || !providerAssigned) ? <Button disabled={preferredPartnerId} onClick={() => this.selectPreferredProvider({ id: provider?.id, lat: provider?.lat, lng: provider?.lng })} className={cx(bt.btnPrimary, bt.primarySmall)}>{formatMessage(messages.assign)}</Button> :
                                    <Button onClick={() => this.selectPreferredProvider({})} className='preferredRemoveBtn'>  {formatMessage(messages.remove)}</Button>
                                }
                            </div>
                        </div>
                    </div>
                    )
                })
                }
            </div >
        )
    }
}

const selector = formValueSelector('ManualBookingForm');

const mapState = (state) => ({
    preferredPartnerId: selector(state, 'preferredPartnerId'),
});

const mapDispatch = {
    change
};


export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(PreferredProviderList)));